/** Standard issue categories (matches bootstrap / InitialConfigurationScript). */
export const DEFAULT_ISSUE_CATEGORIES = [
  { issueCategoryDescription: 'Administrative', sortOrder: 10 },
  { issueCategoryDescription: 'Logistical', sortOrder: 20 },
  { issueCategoryDescription: 'Investigator responsibilities', sortOrder: 30 },
  { issueCategoryDescription: 'Subject data', sortOrder: 40 },
  { issueCategoryDescription: 'Safety', sortOrder: 50 },
  { issueCategoryDescription: 'Site Staff & Training', sortOrder: 60 },
  { issueCategoryDescription: 'Investigational Medicinal Product', sortOrder: 70 },
  { issueCategoryDescription: 'Data quality', sortOrder: 80 },
  { issueCategoryDescription: 'Electronic systems', sortOrder: 90 },
  { issueCategoryDescription: 'Others', sortOrder: 100 },
];

/** Standard profiles (matches bootstrap EnsureProfilesAsync). */
export const DEFAULT_PROFILES = [
  { profileCode: 'CRA', profileDescription: 'CRA' },
  { profileCode: 'PM', profileDescription: 'PM' },
  { profileCode: 'SRM', profileDescription: 'SRM' },
  { profileCode: 'VWR', profileDescription: 'Viewer' },
  { profileCode: 'PI', profileDescription: 'PI' },
];

/** Standard priorities (matches bootstrap EnsurePrioritiesAsync). */
export const DEFAULT_PRIORITIES = [
  { priorityDescription: 'Low', hours: 24 },
  { priorityDescription: 'Medium', hours: 12 },
  { priorityDescription: 'High', hours: 4 },
  { priorityDescription: 'Critical', hours: 1 },
];

/** Menu operations — parents before children (matches DatabaseSeedService.EnsureFullOperationMst + 0619). */
export const DEFAULT_OPERATIONS = [
  { operationCode: '-999', operationName: 'Root', operationPath: '#', parentOperationCode: null, seqNo: 0 },
  { operationCode: '0597', operationName: 'Dashboard', operationPath: '#', parentOperationCode: '-999', seqNo: 1 },
  { operationCode: '0598', operationName: 'Dashboard', operationPath: '/dashboard', parentOperationCode: '0597', seqNo: 1 },
  { operationCode: '0599', operationName: 'PM Dashboard', operationPath: '/pm-dashboard', parentOperationCode: '0597', seqNo: 2 },
  { operationCode: '0600', operationName: 'Setup & Configuration', operationPath: '#', parentOperationCode: '-999', seqNo: 2 },
  { operationCode: '0601', operationName: 'Site Feasibility & Selection', operationPath: '/sitefeasible', parentOperationCode: '0600', seqNo: 1 },
  { operationCode: '0602', operationName: 'Site Onboarding', operationPath: '/sites', parentOperationCode: '0600', seqNo: 2 },
  { operationCode: '0619', operationName: 'Study Configuration', operationPath: '/configuration', parentOperationCode: '0600', seqNo: 3 },
  { operationCode: '0603', operationName: 'Planner', operationPath: '#', parentOperationCode: '-999', seqNo: 3 },
  { operationCode: '0604', operationName: 'Visit Scheduling Planner', operationPath: '/planner', parentOperationCode: '0603', seqNo: 1 },
  { operationCode: '0605', operationName: 'Operations', operationPath: '#', parentOperationCode: '-999', seqNo: 4 },
  { operationCode: '0606', operationName: 'Monitoring Visit & Report Management', operationPath: '/visits', parentOperationCode: '0605', seqNo: 1 },
  { operationCode: '0612', operationName: 'Mail Management', operationPath: '/mail-management', parentOperationCode: '0605', seqNo: 2 },
  { operationCode: '0607', operationName: 'Reports & Analytics', operationPath: '#', parentOperationCode: '-999', seqNo: 5 },
  { operationCode: '0608', operationName: 'Reports', operationPath: '/reports', parentOperationCode: '0607', seqNo: 1 },
  { operationCode: '0609', operationName: 'Case Report Forms', operationPath: '#', parentOperationCode: '-999', seqNo: 6 },
  { operationCode: '0610', operationName: 'CRF Forms', operationPath: '/crf', parentOperationCode: '0609', seqNo: 1 },
  { operationCode: '0611', operationName: 'CRF Management', operationPath: '/crf/management', parentOperationCode: '0609', seqNo: 2 },
];
